(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("languageService", ['p2DataTaskService', function (p2DataTaskService) {
        var service = {
            list: function () {
                return p2DataTaskService.call(57, {});
            }
        }

        return service;
    }]);
})();